import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-16 right-4 p-4 text-sm text-green-800 border border-green-300 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400 dark:border-green-800 z-50",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "flex-shrink-0 inline w-5 h-5 mr-3",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Info", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Success alert!", -1)


  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessMessage',
  props: {
    showSuccessMessage: Boolean,
    successMessage: String,
  },
  setup(__props) {

  
  
return (_ctx: any,_cache: any) => {
  return (__props.showSuccessMessage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", null, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(__props.successMessage), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})